import * as yup from 'yup';

export const CountryFilterSchema = yup.object().shape({
  countryFilter: yup.string().required('common:validation.fieldRequired'),
});

export type CountryFilter = yup.InferType<typeof CountryFilterSchema>;
